"use client";

import { useState } from "react";
import { cn } from "@/lib/utils";

/** Theme-independent backing for unknown transparent customer marks. */
export function PublicBrandImage({ src, name, className }: {
  src: string;
  name: string;
  className?: string;
}) {
  const [failedSource, setFailedSource] = useState<string | null>(null);
  if (failedSource === src) {
    return <span className="max-w-40 truncate text-xs font-medium" title={name}>{name}</span>;
  }
  return (
    // A neutral mid-tone remains behind the mark in both themes: neither
    // a white transparent logo nor a black one disappears with a theme flip.
    // EmbedWatermark deliberately retains its existing website appearance.
    // eslint-disable-next-line @next/next/no-img-element
    <img src={src} alt={name} onError={() => setFailedSource(src)}
      className={cn("rounded-md bg-[#767676] p-1.5 object-contain ring-1 ring-black/10", className)} />
  );
}
